<script setup>
import { reactive } from 'vue'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide'

const state = reactive({
    options: {
        arrows: false
    }
})

const props = defineProps({
    blockId: {
        type: String,
        default: () => ''
    },
    testimonials: {
        type: Array,
        default: () => []
    }
})
</script>

<template>
    <section class="c-testimonials" v-if="testimonials && testimonials.length" :id="'#'+blockId">
        <div class="container">
            <div class="c-testimonials__carousel">
                <Splide :options="state.options" :has-track="false">
                    <div class="c-testimonials__carousel-inner">
                        <SplideTrack>
                            <SplideSlide v-for="testimonial in testimonials">
                                <div class="row">
                                    <div class="col-lg-11 offset-lg-1">
                                        <div class="carousel-item">
                                            <div class="left">
                                                <p v-if="testimonial.testimonial_text">
                                                    {{ testimonial.testimonial_text }}
                                                </p>
                                                <span v-if="testimonial.testimonial_name" class="name">
                                                    {{ testimonial.testimonial_name }}
                                                </span>
                                                <span v-if="testimonial.testimonial_role" class="role">
                                                    {{ testimonial.testimonial_role }}
                                                </span>
                                            </div>
                                            <div class="right">
                                                <figure v-if="testimonial.testimonial_image_url">
                                                    <picture>
                                                        <img :src="testimonial.testimonial_image_url" :alt="testimonial.testimonial_name ?? ''">
                                                    </picture>
                                                </figure>
                                                <div class="quote hidden-md-up">
                                                    <img src="/img/quote.svg" :alt="testimonial.testimonial_name ?? ''">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SplideSlide>
                        </SplideTrack>
                    </div>
                </Splide>
            </div>
        </div>
    </section>
</template>
